import type { ConcreteIdea, Idea } from '@thinkalpha/platform-ws-client/contracts/ideas/index.js';

/**
 * Returns a copy of `idea` with `ConcreteIdea`-only server-managed fields removed.
 *
 * Why: dirty idea drafts are persisted as full objects (see `toContractModel` on each
 * widget definition). After a round-trip, the wire-form `incomingIdea` typed as `Idea`
 * may at runtime still carry stale `permissions`, timestamps, or version chain pointers
 * captured from a prior fetch. When we merge a draft into a freshly-fetched `serverIdea`
 * we want server-managed metadata to always come from the fresh fetch, never from the
 * stale draft.
 */
export function stripServerManagedFields<T extends Idea>(idea: T): T {
    const {
        permissions: _permissions,
        createdAt: _createdAt,
        discardedAt: _discardedAt,
        previousVersion: _previousVersion,
        nextVersion: _nextVersion,
        ...rest
    } = idea as T & Partial<ConcreteIdea>;
    return rest as T;
}
